import type { Hco } from '@/core/graphql/generated/types';
import { paths } from '@/core/router/paths';
import { replaceRouteParams } from '@/utils/url/replaceRouteParams';

import { hcoUrl } from './hcoUrl';

export const getHcoProfileLink = (hco: Hco): string => {
	const slug = hcoUrl({ name: hco.hcoNameCda_V, id: hco.vid_V });
	return slug ? replaceRouteParams(paths.hco, { hcoId: slug }) : '';
};
